import LockAccessOverlay from './LockAccessOverlay';
import './LockAccessOverlay.scss';

export default LockAccessOverlay;